<template>
  <div className="animated">
    <b-card class="animated fadeIn">
      <b-card-body>
        <h1>Proformas</h1>

        <b-modal id="modal-proforma" centered size="lg" title="Proforma" @ok="proforma = null" ok-only>
          <div class="text-center">
            <b-spinner v-if="!proforma" label="Spinning"></b-spinner>
          </div>
          <report v-if="proforma" :proforma="proforma"></report>
        </b-modal>

        <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref="table" id="dataTable">
          <template slot="afterFilter">
            <tr class="VueTables__no-results">
              <b-button @click="resetFilters">Limpiar filtro</b-button>
            </tr>

            <tr v-if="loading" class="VueTables__no-results">
              <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
            </tr>
          </template>

          <template slot="status" slot-scope="props">
            <a href="#" :class="props.row.status === 'Pagada' ? 'disabled' : ''">
              <b-badge pill :variant="getBadge(props.row.status)">{{ props.row.status }}</b-badge>
            </a>
          </template>

          <div class="text-right" slot="actions" slot-scope="props">
            <a
              target="_blank"
              href="#"
              @click.prevent="getProforma(props.row.id)"
              class="fa fa-lg fa-search text-primary"
            ></a
            >&nbsp;
            <!--            <a target="_blank" href="#" @click.prevent="emailModal(props.row)" class="fa fa-lg fa-send text-primary"></a>&nbsp;-->
            <a
              target="_blank"
              href="#"
              @click.prevent="downloadWithAxios(props.row.id, props.row.number)"
              class="fa fa-lg fa-file-pdf-o text-danger"
            ></a
            >&nbsp;
            <!--            <a target="_blank" href="#" @click.prevent="editWaybill(props.row.id)" class="fa fa-lg fa-edit text-primary"></a>&nbsp;-->
          </div>

          <div slot="beforeLimit">
            <download-excel
              class="btn"
              :fetch="fetchData"
              :fields="json_fields2"
              worksheet="Proformas"
              :name="name"
              :before-generate="startDownload"
              :before-finish="finishDownload"
            >
              <b-link>Descargar</b-link>
            </download-excel>
          </div>
        </v-server-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import Report from "./Report";

numeral.locale("es");
window.axios = require("axios");
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "DataTable",
  components: {
    ServerTable,
    Report
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
  },
  data() {
    return {
      loading: false,
      proforma: null,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields2: {
        Id: "number",
        Número: "company_proformas_count",
        Exportadora: "client_customer_name",
        Productor: "company_name",
        Fecha_emisión: "issue_date",
        Desde: "start_date",
        Hasta: "end_date",
        Descripción: "description",
        Fecha_Notificación: "notification_date",
        Fecha_de_pago: "payment_date",
        Status: "status",
        Cambio: "currency"
      },

      columns: [
        "number",
        "company_proformas_count",
        "client_customer_name",
        "company_name",
        "issue_date",
        "start_date",
        "end_date",
        "description",
        "notification_date",
        "payment_date",
        "status",
        "currency",
        "actions"
      ],

      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        // columnsDropdown: true,
        filterByColumn: true,
        listColumns: {
          status: [
            { id: "Emitida", text: "Emitida" },
            { id: "Enviada", text: "Enviada" },
            { id: "Pagada", text: "Pagada" }
          ]
        },
        filterable: ["client_customer_name", "company_name", "number", "status"],
        headings: {
          client_customer_name: "Exportadora",
          company_name: "Productor",
          number: "Id",
          company_proformas_count: "Número",
          issue_date: "Fecha emisión",
          start_date: "Desde",
          end_date: "Hasta",
          notification_date: "Fecha notificación",
          payment_date: "Fecha pago",
          description: "Descripción",
          currency: "Cambio",
          actions: "Acciones"
        },
        debounce: 800,
        columnsDropdown: true,
        columnsDisplay: {
          notificacion_date: "not_desktop",
          payment_date: "not_desktop",
          description: "not_desktop",
          currency: "min_desktop"
        },
        sortable: [],
        sortIcon: { base: "fa", up: "fa-sort-asc", down: "fa-sort-desc", is: "fa-sort" },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  filters: {
    moment(value) {
      return moment(value).format("DD-MM-YYYY");
    }
  },
  computed: {
    name() {
      return "Proformas " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },
    url() {
      return "/trading/proforma/proforma_list/";
    }
  },
  methods: {
    getProforma(a) {
      this.$bvModal.show("modal-proforma");
      this.$axios
        .get("/trading/proforma/" + a + "/")
        .then((res) => {
          this.proforma = res.data;
        })
        .catch((error) => {
          miniToastr.error("Problemas al realizar la operación", "");
          console.log(error);
        });
    },
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Proforma #" + a + ".pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/reports/proforma_pdf/" + a,
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
          miniToastr.success("Pdf generado con éxito.", "Mensaje:");
        })
        .catch((error) => {
          miniToastr.error("Problemas al generar pdf", "Error:");
          console.log(error);
        });
    },
    jsonToQueryString(json) {
      var result = {};
      for (var key in json) {
        if (json[key] !== "") {
          result[key] = json[key];
        }
      }

      var a = encodeURIComponent(JSON.stringify(result));

      return "/trading/proforma/proforma_list/?query=" + a;
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },

    async fetchData() {
      const response = await this.$axios.get(this.jsonToQueryString(this.$refs.table.query));
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    getBadge(item) {
      return item === "Emitida" ? "secondary" : item === "Enviada" ? "success" : "dark";
    }
  }
};
</script>

<style>
a.disabled {
  pointer-events: none;
  cursor: default;
}

#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__columns-dropdown {
    padding-right: 20px;
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
